import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";
import { apiFetch, type ApiFetchOptions } from "./apiFetch.ts";

export interface UseApiQueryOptions<T> extends Omit<UseQueryOptions<T, Error>, "queryFn"> {
  url: string;
  fetchOptions?: ApiFetchOptions;
}

export function useApiQuery<T = unknown>(options: UseApiQueryOptions<T>): UseQueryResult<T, Error> {
  const { url, fetchOptions, ...rest } = options;
  return useQuery<T, Error>({
    ...rest,
    queryFn: async ({ signal }) => apiFetch<T>(url, { ...fetchOptions, signal }),
  });
}
